export default {"src":"/_next/static/media/store_offer_bonus_tag_pink.a3e998bb.svg","height":50,"width":112,"blurWidth":0,"blurHeight":0};